import MyInvestmentsOpportunities from './container';

export default MyInvestmentsOpportunities;
